import typesPay from '../../../../shared/constants/typesPay';
import convertFormatDate from '../../../../shared/utils/convertFormatDate';
import formatPrice from '../../../../shared/utils/formatPrice';

export function sortByDateAndId(array) {
  array?.sort((a, b) => {
    const dateA = new Date(a.payDate);
    const dateB = new Date(b.payDate);

    if (dateA > dateB) {
      return -1;
    }
    if (dateA < dateB) {
      return 1;
    }
    // Сортировка по убыванию id, если даты равны
    return b.id - a.id;
  });

  return array;
}

export const prepareRows = (payments) =>
  payments?.map((e) => {
    const newDAta = JSON.parse(JSON.stringify(e));
    newDAta.id = e.compPaymentId;
    newDAta.companyName = e.companyAccount.company.name;
    newDAta.accountId = e.companyAccount.companyAccountId;
    newDAta.typePayCurrent = typesPay.find((typesPayCurrent) => typesPayCurrent.id === e.type).value;
    newDAta.textAlignRight = formatPrice(e.sum);
    newDAta.comment = e.comment ? e.comment?.split('. ').map((item) => `${item}.`) : '-';
    newDAta.payDateCurrent = convertFormatDate(e.payDate).toFormat.substr(0, 10);
    newDAta.rowColor = e.type === typesPay[0].id ? '#f553538f' : e.type === typesPay[1].id ? '#2f7d3182' : '#ffff008a';
    return newDAta;
  });
